export default [
    {
        name: 'propsName',
        def: 'default value',
        desc: 'description',
    },
];
